import { ReactNode } from 'react'
import { useLocation, useNavigate, useOutletContext } from 'react-router-dom'

import { Box, Tabs } from '@factorialco/deprecated-design-system'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useFeatures } from 'modules/core/hooks/useFeatures'
import i18n from 'modules/core/lib/i18n'

interface OutletContext {
  competenciesAvailable: boolean
}

interface Props {
  roleId: string
  actions?: ReactNode
}

export function RoleTabs({ roleId }: Props) {
  const location = useLocation()
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const { competenciesAvailable } = useOutletContext<OutletContext>()
  const { has_dev_job_catalog_career_path: hasNewCareerPath } = useFeatures([
    'dev_job_catalog_career_path',
  ])

  return (
    <Box position="relative" width="full">
      <Tabs currentId={location.pathname} onTabClicked={(to) => navigate(to)}>
        <Tabs.Tab
          id={navigation.employees.jobCatalog.role.fullPath({ id: roleId })}
          label={i18n.t('job_catalog.employees.title')}
        />

        <Tabs.Tab
          id={navigation.employees.jobCatalog.role.salaryRanges.fullPath({ id: roleId })}
          label={i18n.t('job_catalog.salary_ranges.title')}
        />

        {competenciesAvailable ? (
          hasNewCareerPath ? (
            <Tabs.Tab
              id={navigation.employees.jobCatalog.role.careerPath.fullPath({ id: roleId })}
              label={i18n.t('job_catalog.career_path.title')}
            />
          ) : (
            <Tabs.Tab
              id={navigation.employees.jobCatalog.role.competencies.fullPath({ id: roleId })}
              label={i18n.t('job_catalog.competencies.title')}
            />
          )
        ) : (
          <></>
        )}
      </Tabs>
    </Box>
  )
}
